/**
 * To encrypt the id param in url
 */
export const base64EncryptPostId = false;
